<app-layout>
  <div class="main">
    <div class="header-table">
      <app-titulo>Relatório Estoque</app-titulo>
      <div class="header-buttons" *ngIf="reportType">
        <app-botao *ngIf="isInventario" type="secundario" class="button" text="Exportar PDF"
          icon="assets/download.svg" (click)="exportarPdfInventario()"></app-botao>
        <app-botao *ngIf="isMovimentacoes" type="secundario" class="button" text="Exportar PDF"
          icon="assets/download.svg" (click)="exportarPdfMovimentacoes()"></app-botao>
        <app-botao *ngIf="isVendasEstoque" type="secundario" class="button" text="Exportar PDF"
          icon="assets/download.svg" (click)="exportarPdfVendasEstoque()"></app-botao>
        <app-botao *ngIf="isPosicao" type="secundario" class="button" text="Exportar PDF"
          icon="assets/exportar-excel.svg" (click)="exportarPdfPosicao()"></app-botao>
        <app-botao type="secundario" class="button" text="Exportar Excel" icon="assets/exportar-excel.svg"
          (click)="exportarExcel()"></app-botao>
      </div>
    </div>

    <div class="desktop grid-outline">
      <div class="grid-header">
        <div class="intern-title">{{ reportTitle }}</div>
        <div class="align-button">
          <form [formGroup]="form" class="table-filters" (ngSubmit)="$event.preventDefault()">
            <app-input type="select" label="Relatório" placeholder="Selecione" name="REPORT_TYPE"
              [ngModel]="reportType" [ngModelOptions]="{standalone: true}"
              [selectData]="reportOptions" [preserveOrder]="true"
              (ngModelChange)="onChangeReportType($event)" width="100%"></app-input>

            <app-input *ngIf="isVendasEstoque" type="number" label="Nº do Caixa" placeholder="Serviço ou estoque"
              name="PK_CAIX" formControlName="PK_CAIX" width="100%"></app-input>
            <app-input *ngIf="isVendasEstoque" label="Cliente" placeholder="Digite o nome" name="NM_CLNT"
              formControlName="NM_CLNT" width="100%"></app-input>
            <app-input *ngIf="isVendasEstoque" label="Operador" placeholder="Digite o nome" name="NM_FUNC"
              formControlName="NM_FUNC" width="100%"></app-input>

            <app-input type="datetime-local" label="Data Início" name="DT_INIC" formControlName="DT_INIC"
              width="100%"></app-input>
            <app-input type="datetime-local" label="Data Final" name="DT_FIM" formControlName="DT_FIM"
              width="100%"></app-input>

            <div class="filter-switch" *ngIf="isInventario">
              <label>Somente em estoque</label>
              <label class="switch">
                <input type="checkbox" [checked]="!!form.controls.FL_EM_ESTQ.value"
                  (change)="toggleEmEstoque($any($event.target).checked)">
                <span class="slider"></span>
              </label>
            </div>
            <div class="filter-switch" *ngIf="isInventario">
              <label>Somente estoque baixo</label>
              <label class="switch">
                <input type="checkbox" [checked]="!!form.controls.FL_ESTQ_BX.value"
                  (change)="toggleEstoqueBaixo($any($event.target).checked)">
                <span class="slider"></span>
              </label>
            </div>

            <app-input *ngIf="!isInventario" type="select" label="Produto" name="FK_PROD"
              formControlName="FK_PROD" width="100%" [selectData]="produtoOptions" coerceValue="number"
              [preserveOrder]="true"></app-input>

            <app-input *ngIf="isMovimentacoes" type="select" label="Tipo" name="NU_TIPO_MOVM"
              formControlName="NU_TIPO_MOVM" width="100%" [selectData]="tipoMovimentacaoOptions"
              coerceValue="number" [preserveOrder]="true"></app-input>
            <app-input *ngIf="isMovimentacoes" type="select" label="Origem" name="NU_ORIG_MOVM"
              formControlName="NU_ORIG_MOVM" width="100%" [selectData]="origemMovimentacaoOptions"
              coerceValue="number" [preserveOrder]="true"></app-input>

            <app-input *ngIf="isVendasEstoque" type="select" label="Forma de Pagamento" placeholder="Selecione"
              name="NU_TIPO_PGMT_CAIX" formControlName="NU_TIPO_PGMT_CAIX" width="100%"
              [selectData]="formaPagamentoOptions" coerceValue="number" [preserveOrder]="true"></app-input>

            <div class="filter-actions" *ngIf="reportType">
              <app-botao type="secundario" class="button" text="Pesquisar" buttonType="button"
                (click)="pesquisar()"></app-botao>
            </div>
          </form>
        </div>
      </div>

      <div class="table-scroll" *ngIf="reportType && !isLoading">
        <app-tabela [data]="tableData" [columns]="tableColumns"></app-tabela>
      </div>

      <div *ngIf="isMovimentacoes && !isLoading && resumoMovimentacoes.length" class="resumo-periodo">
        <div class="intern-title">RESUMO DO PERÍODO</div>
        <div class="table-scroll">
          <app-tabela [data]="resumoMovimentacoes" [columns]="resumoMovimentacoesColumns"></app-tabela>
        </div>
      </div>

      <div *ngIf="isInventario && !isLoading && tableData.length" class="rodape-tabela">
        <h2 class="valor">Valor Total: {{ valorTotalFormatado }}</h2>
      </div>

      <div *ngIf="isVendasEstoque && !isLoading && tableData.length" class="rodape-tabela">
        <h2 class="valor">Quantidade Total: {{ quantidadeTotal }}</h2>
        <h2 class="valor">Valor Total: {{ valorTotalFormatado }}</h2>
      </div>

      <div *ngIf="isPosicao && !isLoading && tableData.length" class="rodape-tabela">
        <h2 class="valor">Inicial: {{ totaisFormatados.qtInic }} / {{ totaisFormatados.vlInic }}</h2>
        <h2 class="valor">Saídas: {{ totaisFormatados.qtSaid }} / {{ totaisFormatados.vlSaid }}</h2>
        <h2 class="valor">Atual: {{ totaisFormatados.qtAtual }} / {{ totaisFormatados.vlAtual }}</h2>
      </div>
    </div>
  </div>

  <app-subtitulo *ngIf="reportType && !isLoading && !tableData.length && !hasSearched">
    Ajuste os filtros e clique em Pesquisar.
  </app-subtitulo>

  <app-subtitulo *ngIf="reportType && !isLoading && !tableData.length && hasSearched">
    Nenhum registro encontrado.
  </app-subtitulo>

  <div class="paginacao" *ngIf="isVendasEstoque">
    <app-paginacao *ngIf="tableData.length" [pages]="maxPages" (selectedPage)="mudarPagina($event)"></app-paginacao>
  </div>

  <app-loader [isLoading]="isLoading"></app-loader>
</app-layout>
